// Swatch / Lifestyle image toggle on the product page. Each variant view loads
// with the swatch (variant) image active; clicking "Lifestyle" swaps to the
// main non-variant product image (and back). Progressive enhancement — without
// JS the swatch image (marked is-active in markup) simply stays shown.
(function () {
  var toggles = document.querySelectorAll('.js-product-image-toggle');

  toggles.forEach(function (toggle) {
    var container = toggle.closest('.product__slider-container');
    if (!container) return;

    var buttons = toggle.querySelectorAll('.image-toggle__btn');
    var views = container.querySelectorAll('.js-product-view');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.getAttribute('data-product-view');

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });

        views.forEach(function (image) {
          image.classList.toggle('is-active', image.getAttribute('data-product-view') === view);
        });
      });
    });
  });
})();
